var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6106 15.6815L14.0506 11.0005V6.00049C14.0506 2.68649 11.3646 0.000488281 8.05059 0.000488281C4.73659 0.000488281 2.05059 2.68649 2.05059 6.00049V11.0005L0.490595 15.6815C0.273595 16.3305 0.756595 17.0005 1.44059 17.0005H5.05059C5.05059 18.6575 6.39359 20.0005 8.05059 20.0005C9.70759 20.0005 11.0506 18.6575 11.0506 17.0005H14.6606C15.3446 17.0005 15.8276 16.3305 15.6106 15.6815ZM8.05059 19.0005C6.94759 19.0005 6.05059 18.1035 6.05059 17.0005H10.0506C10.0506 18.1035 9.15359 19.0005 8.05059 19.0005ZM1.43859 15.9975L2.99959 11.3165C3.03359 11.2145 3.05059 11.1075 3.05059 11.0005V6.00049C3.05059 3.24349 5.29359 1.00049 8.05059 1.00049C10.8076 1.00049 13.0506 3.24349 13.0506 6.00049V11.0005C13.0506 11.1075 13.0676 11.2145 13.1016 11.3165L14.6606 16.0005L1.43859 15.9975Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.4d2e298a73f45876dc6886b631856400.svg";
export { ForwardRef as ReactComponent };